import { AppContext, ExAppContext } from '../Context';
import { useContext, Fragment } from 'react';
// import { useLocation } from 'react-router-dom';

//frame components
import Header from '../components/Header';
import NavBar from '../components/NavBar';
// import Footer from '../components/Footer';

interface Props {

}

const FrameComponentsController: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);

    return (
        <Fragment>
            {
                !appContext.headerShouldHide && Object.keys(appContext.user).length > 0 ?
                    <Header user={appContext.user} headerBackAction={appContext.headerBackAction} headerTitle={appContext.headerTitle}/>
                    :
                    null
            }
            {
                !appContext.navBarShouldHide ?
                    <NavBar viewMode={exAppContext.viewMode} />
                    :
                    null
            }
            {/* {
                !appContext.footerShouldHide ?
                    <Footer />
                    :
                    null
            } */}
        </Fragment>
    );
}
export default FrameComponentsController;